import React from 'react'
import { NavLink } from 'react-router-dom'
// import { header } from "../../config/imagesLink";
import HomeSharpIcon from '@mui/icons-material/HomeSharp';
import HubSharpIcon from '@mui/icons-material/HubSharp';
import BusinessSharpIcon from '@mui/icons-material/BusinessSharp';
import PersonSearchSharpIcon from '@mui/icons-material/PersonSearchSharp';
import WorkOutlineSharpIcon from '@mui/icons-material/WorkOutlineSharp';
import TopNotification from './TopNotification';
import TopMessage from './TopMessage';

const Footer = ({ notifiCount, setNotifiCount, NotificationCount, msgCount, setMsgCount, MessagesCount, mobileHeaderPanel, setMobileHeaderPanel }) => {
    const guestModeData = localStorage.getItem("guestMode");

    return (
        <>
            <div className="d-flex footer-nav">
                {/* <ul> */}
                <NavLink to='/NewsFeed'>
                    <li className='navLinks'>
                        <HomeSharpIcon className="material-symbols-sharp" /> </li>
                </NavLink>
                <NavLink to='/Connections'>
                    <li className='navLinks'><HubSharpIcon className="material-symbols-sharp" /> </li>
                </NavLink>
                <NavLink to='/Companies'>
                    <li className='navLinks'><BusinessSharpIcon className="material-symbols-sharp" /> </li>
                </NavLink>
                <NavLink to='/People'>
                    <li className='navLinks'><PersonSearchSharpIcon className="material-symbols-sharp" /> </li>
                </NavLink>
                <NavLink to='/SearchJob'>
                    <li className='navLinks'><WorkOutlineSharpIcon className="material-symbols-sharp" /> </li>
                </NavLink>
                {guestModeData !== "true" && (
                    <>
                        <li className='navLinks footer-action'>
                            <TopNotification
                                notifiCount={notifiCount}
                                setNotifiCount={setNotifiCount}
                                NotificationCount={NotificationCount}
                                isOpen={mobileHeaderPanel === "notif"}
                                toggle={() => setMobileHeaderPanel((panel) => panel === "notif" ? null : "notif")}
                            />
                        </li>
                        <li className='navLinks footer-action'>
                            <TopMessage
                                MessagesCount={MessagesCount}
                                msgCount={msgCount}
                                setMsgCount={setMsgCount}
                                isOpen={mobileHeaderPanel === "msg"}
                                toggle={() => setMobileHeaderPanel((panel) => panel === "msg" ? null : "msg")}
                            />
                        </li>
                    </>
                )}
                {/* </ul> */}
            </div>
        </>
    )
}

export default Footer